











































































































































import { ZboziDruh } from '@/modules/ciselnik/skladove/zbozidruh';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';
import { editFactory } from '@/main/pages';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from '../constants';

export default editFactory(NAME, store).extend({
	components: {
		ZboziDruhSelect: ZboziDruh.components.Select,
		SkladMistoSelect: SkladMisto.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				zbozi: `${this.storeUri}/${editMutations.ND_POHYB_ZBOZI_SELECT_MAPPER}`,
				skladMisto: `${this.storeUri}/${editMutations.ND_POHYB_SKLAD_MISTO_SELECT_MAPPER}`,
				rabatSk: `${this.storeUri}/${editMutations.ND_POHYB_RABAT_SK_SELECT_MAPPER}`,
				dodavatel: `${this.storeUri}/${editMutations.ND_POHYB_DODAVATEL_SELECT_MAPPER}`,
				nakladoveSterdisko: `${this.storeUri}/${editMutations.ND_POHYB_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		zboziDruhFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		rabatSkFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		skladmistoFilter() {
			return {
				SkladOzn: this.SkladOzn,
				VyrazenPrp: false,
			};
		},
	},
});
